var React = require("react");

var Icon = require('infl-icons').Icon;
var Tooltip = require('patternity/lib/tooltip');

const MultiIcon = () =>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{width: 16}}>
    <path d="M7,7H17V8.79a.49.49,0,0,0,.85.35l2.79-2.79a.5.5,0,0,0,0-.71L17.85,2.85a.5.5,0,0,0-.85.36V5H6A1,1,0,0,0,5,6v4a1,1,0,0,0,2,0ZM17,17H7V15.21a.49.49,0,0,0-.85-.35L3.36,17.65a.5.5,0,0,0,0,.71l2.79,2.79A.5.5,0,0,0,7,20.79V19H18a1,1,0,0,0,1-1V14a1,1,0,0,0-2,0Z"></path>
  </svg>;

const Expiring = () =>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{width: 16}}>
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm3.3 14.71L11 12.41V7h2v4.59l3.71 3.71-1.42 1.41z"></path>
  </svg>;

const Limited = () =>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{width: 16}}>
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
  </svg>;

var ChallengeCardStatusIcon = React.createClass({
  PropTypes: {
    status: React.PropTypes.array,
    challengeId: React.PropTypes.number,
    retrieveChallengeStatusDescription : React.PropTypes.func.isRequired,
    challengeStatusDescription: React.PropTypes.object.isRequired,
    rewriteLook: React.PropTypes.bool
  },

  render: function() {
    var status = this.props.status;

    return(
      <Tooltip
        element={this.determineIcon(status)}
        position="bottom"
        isClickable={false}
        onOpen={this.retrieveChallengeStatus(status)}
        style={{
          content: {
            minWidth: '100px',
            padding: '2px 5px',
            fontSize: '12px'
          }
        }}>

        {this.determineIconDescription(status)}
      </Tooltip>
    )
  },

  determineIcon : function(status){
    const rewriteIcons = {
      'expiring' : <Expiring />,
      'limited' : <Limited />,
      'multi' : <MultiIcon />
    };

    const component = rewriteIcons[status];
    if (component && this.props.rewriteLook) {
      return component;
    }

    var tileIcons = {
      'started' : 'inprogress',
      'expiring' : 'expiring',
      'limited' : 'cursor-click',
      'multi' : 'multi'
    }

    return <Icon icon={tileIcons[status]} />;
  },

  determineIconDescription: function(status) {
    return this.isDifferentChallenge(status) ? "..." : this.props.challengeStatusDescription.statusDescription;
  },

  isDifferentChallenge: function(statusType) {
    return this.props.challengeStatusDescription.challengeId !== this.props.challengeId || this.props.challengeStatusDescription.status !== statusType;
  },

  retrieveChallengeStatus: function(status) {
    return function() {
      this.props.retrieveChallengeStatusDescription(this.props.challengeId, status)
    }.bind(this)
  }
});

module.exports = ChallengeCardStatusIcon;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card_status_icon.jsx